@import '../../styles/mixins';

.datePickerContainer {
  position: relative;
  max-width: 17em;

  &,
  * {
    box-sizing: border-box;
  }

  .pickerBtn {
    position: absolute;
    right: 1em;
    top: 1.25em;

    &.withLabel {
      top: 3.1em;
    }
  }
}

.dateInput {
  @include ellipsis();
  padding-right: 2.5em !important;
}

.week {
  color: red;
  position: absolute;
  font-size: 0.75em;
  left: 1em;
  margin-top: 1em;
}
